import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Row, Card, ProgressBar, Alert } from "react-bootstrap";
import api from "../seller-apis/api";
import axios from "axios";
import servicesApi from "../seller-apis/servicesApi";
import "./profile.css";
import { useAlert } from "react-alert";
import { variables } from "../Variables.json";
import AddnewAddressSeller from "./AddnewAddressSeller";
import {
  deleteSellerAddress,
  fetchProfile,
  fetchSellerAddress,
  updatePic,
  updateSellerProfileOkStatus,
} from "../Actions/Profile/index";
import { useDispatch, useSelector } from "react-redux";
import SellerSupport from "./SellerSupport";

import { useLocation, useRouteMatch } from "react-router-dom";
import LegalPolicy from "./LegalPolicy";
import BankDetails from "./profile/BankDetail";
import ManageAddress from "./profile/ManageAddress";
import ProfileStepsTab from "./profile/ProfileStepsTabs";
import VerifyEmailModal from "./profile/VerifyEmailModal";
import StepComplete from "./profile/StepComplete";
import convertFileToWebP from "../utilities/convertFileToWebP";
import PersonalInfoChange from "./common/PersonalInfoChangeModal";
import AgreementDocument from "./profile/AgreementDocument";
import { GenUtilities } from "../utilities/GenUtilities";
var imagesName = [];
var s3Urls = [];
var gstFileName;
var tanFileName;
var panFileName;
var msmeFileName;

function Profile() {
  const alert = useAlert();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null)

  // Size states

  const [currView, setcurrView] = useState();

  const [responseData, setresponseData] = useState([]);
  const [sellerAddresses, setsellerAddresses] = useState([]);
  const [sellerdescription, setsellerdescription] = useState("");

  // Seller web related states

  const [name, setname] = useState();
  // const [email, setemail] = useState();
  const [docError, setDocError] = useState(false);
  const [email, setemail] = useState(responseData?.email);
  const [changeEmail, setChangeEmail] = useState(false);
  const [oldemail, setOldEmail] = useState(true);
  const [verifyEmailShow, setVerifyEmailShow] = useState(false);

  // Email inline editing states for onboarding
  const [isEmailEditing, setIsEmailEditing] = useState(false);
  const [tempEmail, setTempEmail] = useState("");
  const [emailChanged, setEmailChanged] = useState(false);
  const [originalEmail, setOriginalEmail] = useState("");

  // const [phone, setPhone] = useState(responseData.phoneNumber);
  const [changePhone, setChangePhone] = useState(false);
  const [oldphone, setOldPhone] = useState(true);
  const [changeType, setChangeType] = useState("");

  // Seller support related states

  const [Canvasvis, setCanvasVis] = useState(false);

  // Seller business details related states

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Seller edit description related sttates

  const [descriptionCanvasShow, setdescriptionCanvasShow] = useState(false);
  const handleeditdescriptionshow = () => setdescriptionCanvasShow(true);
  const handleeditdescriptionhide = () => setdescriptionCanvasShow(false);

  const [isVerifiedSeller, setisVerifiedSeller] = useState(false);

  // Alert

  const [showAlert, setshowAlert] = useState(false);
  const [alertMsg, setalertMsg] = useState("");

  // GST PAN TAN Verification
  const [currVerPopup, setcurrVerPopup] = useState();
  const [gstNo, setgstNo] = useState("");
  const [prevGSTNo, setprevGSTNo] = useState("");
  const [tanNo, settanNo] = useState("");
  const [phone, setPhone] = useState("");
  const [panNo, setpanNo] = useState("");
  const [gstStatus, setgstStatus] = useState("");
  const [gstUploadProg, setgstUploadProg] = useState();
  const [tanStatus, settanStatus] = useState("");
  const [tanUploadProg, settanUploadProg] = useState();
  const [panStatus, setpanStatus] = useState("");
  const [panUploadProg, setpanUploadProg] = useState();
  const [tanSeletedFileName, setSeletedTanFileName] = useState("");
  const [gstSeletedFileName, setSeletedGstFileName] = useState("");
  const [panSeletedFileName, setSeletedPanFileName] = useState("");
  const [step, setStep] = useState("step1");
  const [documentViewFile, setDocumentViewFile] = useState("");
  const [docViewShow, setDocViewShow] = useState(false);

  // sl-663
  const [msmeNo, setMsmeNo] = useState("");
  const [msmeStatus, setMsmeStatus] = useState("");
  const [msmeUploadProg, setMsmeUploadProg] = useState();
  const [msmeSeletedFileName, setSelectedMsmeFileName] = useState("");
  const [showMsmeSelectBlock, setShowMsmeSelectBlock] = useState(null);
  const [showMsmeQues, setShowMsmeQues] = useState(true);


  // sl-828(838)
  const [showTanSelectBlock, setShowTanSelectBlock] = useState(null);
  const [showTanQues, setShowTanQues] = useState(true);

  const handleTanSelection = (value) => {
    setShowTanSelectBlock(value);
  };
  const handleMsmeSelection = (value) => {
    setShowMsmeSelectBlock(value);
  };

  const [urlList, seturlList] = useState([]);
  const [urlListshow, seturlListshow] = useState(false);
  const [imgprogress, setimgprogress] = useState()

  // // Bank details

  const [bankDetail, setBankDetails] = useState("");
  // const [acNo, setAcNo] = useState("");
  // const [acName, setAcName] = useState("");
  // const [ifscCode, setIfscCode] = useState("");

  const [showverifyfield, setshowverifyfield] = useState(false);
  const [verifyDisable, setVerifyDisable] = useState(true);
  const [verifyPhoneDisable, setVerifyPhoneDisable] = useState(true);
  const [validEmailMsg, setValidEmailMsg] = useState(null);
  // const [validEmailMsg, setPhoneVerifyDisable] = useState(null);

  // Address related

  const [addressshow, setaddressshow] = useState(false);

  const [confirmPic, setconfirmPic] = useState(false);

  const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));

  const [storePhotos, setStorePhotos] = useState([])
  const location = useLocation();
  // console.log(location?.state);
  const handleAddressClose = () => {
    setaddressshow(false);
  };
  const handleCloseverifyfield = () => {
    setshowverifyfield(false);
    setshowAlert(false);
  };
  const handleShowverifyfield = (spcl) => {
    setcurrVerPopup(spcl);
    setshowverifyfield(true);
    // Reset file variables to require new file upload for resubmit
    if (spcl === "GST") {
      gstFileName = "";
    } else if (spcl === "PAN") {
      panFileName = "";
    } else if (spcl === "TAN") {
      tanFileName = "";
    } else if (spcl === "MSME") {
      msmeFileName = "";
    }
  };
  const pancardValidation = (text = "") => {
    let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regex.test(text.toUpperCase())) {
      return true;
    }
    return false;
  }
  const GSTNumberValidation = (text = "") => {
    let regex = new RegExp("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
    if (regex.test(text.toUpperCase())) {
      return true;
    }
    return false;
  }

  const { isLoading, error, isaddressTabLoading, sellerAddress, msg } =
    useSelector((state) => state.profileReducer);
  const { sellerPic } = useSelector((state) => state.vendorDetailsReducer);


  useEffect(() => {
    if (location?.state && location?.state?.tab === 'support') {
      setStep('step5')
    }
  }, [location]);
  useEffect(() => {
    // console.log(data);
    getProfileInfo();
    fetchSellerAddress(dispatch);
  }, []);

  useEffect(() => {
    let data = {
      "bucket": "seller_doc",
      "key": "mob/products/" + documentViewFile
    }
    if (docViewShow) {
      api.docs.getImage(data).then((res) => {
        setDocumentViewFile(res?.data)
      }).catch(err => console.log(err))
    }
  }, [docViewShow])

  // SL-997
  const handleBusinessCardInit = async (urlL) => {
    let list = [];
    for (let i = 0; i < urlL?.length; i++) {
      let data = {
        "bucket": "seller_doc",
        "key": "mob/products/" + urlL?.[i]
      }
      let res = await api.docs.getImage(data);
      list.push(res?.data);
    }
    setStorePhotos(list);
  }


  useEffect(() => {
    handleBusinessCardInit(urlList)
  }, [urlList])

  const getProfileInfo = () => {
    gstFileName = "";
    tanFileName = "";
    panFileName = "";
    msmeFileName = "";
    // Reset imagesName array to ensure clean state
    imagesName = [];
    api.auth
      .me({})
      .then((res) => {
        console.log(res)
        setresponseData(res.data);
        setemail(res.data.email);
        setPhone(res.data.phoneNumber);
        setname(res.data.name);
        seturlList(res.data.businessCard || [])
        if (res?.data?.businessCard && res.data.businessCard.length > 0) {
          imagesName.push(...res.data.businessCard)
          seturlListshow(true);
        } else {
          seturlListshow(false);
        }
        setgstNo(res.data.gstNo);
        setprevGSTNo(res.data.gstNo);
        settanNo(res.data.tanNo);
        if (res?.data?.tanNo) {
          setShowTanSelectBlock("yes")
        }
        setpanNo(res.data.panNo);
        setMsmeNo(res?.data?.msmeNo);
        if (res?.data?.msmeNo) {
          setShowMsmeSelectBlock("yes")
        }
        gstFileName = res.data.gstFile;
        panFileName = res.data.panFile;
        tanFileName = res.data.tanFile;
        msmeFileName = res.data.msmeFile;
        setSeletedGstFileName(res.data.gstFile);
        setSeletedPanFileName(res.data.panFile);
        setSeletedTanFileName(res.data.tanFile);
        setSelectedMsmeFileName(res.data.msmeFile);
        setsellerdescription(res.data.description);
        if (res.data.gstVerified && res.data.gstVerified.status) {
          setgstStatus(res.data.gstVerified.status);
        }
        if (res.data.tanVerified && res.data.tanVerified.status) {
          settanStatus(res.data.tanVerified.status);
          console.log(res.data.tanVerified.status);
        }
        if (res.data.panVerified && res.data.panVerified.status) {
          setpanStatus(res.data.panVerified.status);
          console.log(res.data.panVerified.status);
        }
        if (res.data.msmeVerified && res.data.msmeVerified.status) {
          setMsmeStatus(res.data.msmeVerified.status);
        }
        if (res.data && res.data.bankDetail) {
          // setAcName(res.data.bankDetail.name);
          // setAcNo(res.data.bankDetail.acno);
          // setIfscCode(res.data.bankDetail.ifsc);
          setBankDetails(res.data.bankDetail);
        }
        if (res?.data?.msmeStatus === false) {
          setShowMsmeSelectBlock("no")
        }
        if (res?.data?.tanStatus === false) {
          setShowTanSelectBlock("no")
        }
        if ('msmeStatus' in res?.data && 'tanStatus' in res?.data && res?.data?.gstNo && res?.data?.panNo && res?.data?.emailVerified) {
          updateSellerProfileOkStatus(dispatch, true)
        }
        if (res.message === "seller fetched") {
          setisVerifiedSeller(true);
        }
      })
      .catch((err) => console.log(err));

  }

  useEffect(() => {
    if (msg.text !== "") {
      alert.show(msg.text, {
        type: msg.type,
      });
    }
  }, [msg]);

  useEffect(() => {
    if (error !== "") {
      alert.show(error, {
        type: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    console.log(msmeStatus)
    if (msmeStatus === "" || msmeStatus === undefined || msmeStatus === "REJECTED" || (msmeStatus === "PENDING" && !responseData?.msmeNo)) {
      setShowMsmeQues(true)
    }
    else {
      setShowMsmeQues(false)
    }
  }, [msmeStatus])

  useEffect(() => {
    console.log(tanStatus)
    if (tanStatus === "" || tanStatus === undefined || tanStatus === "REJECTED" || (tanStatus === "PENDING" && !responseData?.tanNo)) {
      setShowTanQues(true)
    }
    else {
      setShowTanQues(false)
    }
  }, [tanStatus])



  // Change seller picture

  function changeSellerPic(event) {
    if (event.target.files.length < 1) {
      return
    }
    updatePic(dispatch, { file: event.target.files, sellerId: vendorId });
  }

  // Delete seller address

  function deleteSellerAddressFun(id, index) {
    deleteSellerAddress(dispatch, {
      id: id,
      index: index,
    });
  }

  // Upload tan file
  function uploadTan(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let limit = event.target.files.length;
    let filesSize = 0;
    for (let i = 0; i < limit; i++) {
      filesSize = filesSize + event.target.files[i].size;
    }
    if (filesSize <= variables.limit.RegisterVendor.tanSize) {
      for (let i = 0; i < 1; i++) {
        console.log(i);
        if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png', '.pdf'])) {
           alert.info('Please upload only valid JPG, JPEG, PNG or PDF files.');
           event.target.value = "";
           return;
        }
        var str = event.target.files[i].name;
        setSeletedTanFileName(str);
        // let extension = event.target.files[i].name.slice(
        //   event.target.files[i].name.lastIndexOf(".")
        // );
        const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
        console.log(str.lastIndexOf("."));
        comImg = str.replace(0, str.lastIndexOf("."));
        console.log(comImg);
        imageFinal = GenUtilities.removeSpacesFromName("tan_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        var data = {
          imageName: imageFinal,
          type: "products",
          bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                settanUploadProg(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                settanUploadProg();
                setshowAlert(false);
                tanFileName = imageFinal;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));

        console.log(tanFileName);
      }
    } else {
      // document.getElementById("tanInput").value = "";
      alert.info("File size can be upto 2 Mb max.");
    }
  }

  // Upload gst file

  function uploadGst(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let limit = event.target.files.length;
    let filesSize = 0;
    for (let i = 0; i < limit; i++) {
      filesSize = filesSize + event.target.files[i].size;
    }
    if (filesSize <= variables.limit.RegisterVendor.gstSize) {
      for (let i = 0; i < 1; i++) {
        console.log(i);
        if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png', '.pdf'])) {
           alert.info('Please upload only valid JPG, JPEG, PNG or PDF files.');
           event.target.value = "";
           return;
        }
        var str = event.target.files[i].name;
        setSeletedGstFileName(str);
        // let extension = event.target.files[i].name.slice(
        //   event.target.files[i].name.lastIndexOf(".")
        // );
        const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
        comImg = str.replace(0, str.lastIndexOf("."));
        imageFinal = GenUtilities.removeSpacesFromName("gst_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        var data = {
          imageName: imageFinal,
          type: "products",
          bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setgstUploadProg(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                setgstUploadProg();
                gstFileName = imageFinal;
                setshowAlert(false);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));

        console.log(gstFileName);
      }
    } else {
      // document.getElementById("gstInput").value = "";
      alert.info("File size can be upto 2 Mb max.");
    }
  }

  // Upload pan file

  function uploadPan(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let limit = event.target.files.length;
    let filesSize = 0;
    for (let i = 0; i < limit; i++) {
      filesSize = filesSize + event.target.files[i].size;
    }
    if (filesSize <= variables.limit.RegisterVendor.panSize) {
      for (let i = 0; i < 1; i++) {
        console.log(i);
        if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png', '.pdf'])) {
           alert.info('Please upload only valid JPG, JPEG, PNG or PDF files.');
           event.target.value = "";
           return;
        }
        var str = event.target.files[i].name;
        setSeletedPanFileName(str);
        // let extension = event.target.files[i].name.slice(
        //   event.target.files[i].name.lastIndexOf(".")
        // );
        const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
        comImg = str.replace(0, str.lastIndexOf("."));
        imageFinal = GenUtilities.removeSpacesFromName("pan_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        panFileName = imageFinal;
        console.log(imageFinal);
        var data = {
          imageName: imageFinal,
          type: "products",
          bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setpanUploadProg(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                setpanUploadProg();
                console.log(response);
                panFileName = imageFinal;
                setshowAlert(false);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));
      }
    } else {
      document.getElementById("panInput").value = "";
      alert.info("File size can be upto 2 Mb max.");
    }
  }

  // Upload Msme
  function uploadMsme(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let limit = event.target.files.length;
    let filesSize = 0;
    for (let i = 0; i < limit; i++) {
      filesSize = filesSize + event.target.files[i].size;
    }
    if (filesSize <= variables.limit.RegisterVendor.msmeSize) {
      for (let i = 0; i < 1; i++) {
        console.log(i);
        if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png', '.pdf'])) {
           alert.info('Please upload only valid JPG, JPEG, PNG or PDF files.');
           event.target.value = "";
           return;
        }
        var str = event.target.files[i].name;
        setSelectedMsmeFileName(str);
        // let extension = event.target.files[i].name.slice(
        //   event.target.files[i].name.lastIndexOf(".")
        // );
        const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
        comImg = str.replace(0, str.lastIndexOf("."));
        console.log(comImg);
        imageFinal = GenUtilities.removeSpacesFromName("msme_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        var data = {
          imageName: imageFinal,
          type: "products",
          bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                setMsmeUploadProg(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                setMsmeUploadProg();
                setshowAlert(false);
                msmeFileName = imageFinal;
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));
      }
    } else {
      // document.getElementById("tanInput").value = "";
      alert.info("File size can be upto 2 Mb max.");
    }
  }

  function resubmitdoc(doc) {
    if (doc === "gst") {
      console.log(gstNo, gstFileName)
      if (gstUploadProg && gstUploadProg > 0) {
        setshowAlert(true);
        setalertMsg("Please wait for GST upload to complete!");
        alert.info("Please wait for GST upload to complete!");
      } else if (gstFileName === "" || gstFileName == undefined) {
        setshowAlert(true);
        setalertMsg("Please upload GST File");
        alert.info("Please upload GST File");
      } else if (gstNo === "" || gstNo === undefined) {
        setshowAlert(true);
        setalertMsg("Please enter GST no");
        alert.info("Please enter a valid GST no");
      } else {
        const regex = new RegExp(
          "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
        );
        if (regex.test(gstNo.toUpperCase())) {
          let data = {
            gstNo: gstNo.toUpperCase(),
            gstFile: gstFileName,
            resubmitType: "GST",
            gstUpdate: gstNo.toUpperCase() == prevGSTNo?.toUpperCase() ? false : true,
            gstVerified: {
              status: "PENDING",
              verifiedBy: "",
            },
          };
          api.seller
            .updateInfo(data)
            .then((res) => {
              if (res.message == 'GST already added') {
                setshowAlert(true);
                setalertMsg("GST already registered");
                alert.info(res.message);
              } else {
                getProfileInfo();
                handleCloseverifyfield();
              }
            })
            .catch((err) => console.log(err));
        } else {
          setshowAlert(true);
          setalertMsg("Please enter a valid GST no");
          alert.info("Please enter a valid GST no");
        }
      }
    } else if (doc === "tan") {
      if (tanNo === "" || tanNo === undefined || tanNo.length !== 10) {
        setshowAlert(true);
        setalertMsg("Please enter a valid TAN no");
        alert.info("Please enter a valid TAN no");
      } else if (tanUploadProg && tanUploadProg > 0) {
        setshowAlert(true);
        setalertMsg("Please wait for TAN upload to complete!");
        alert.info("Please wait for TAN upload to complete!");
      } else {
        let data = {
          tanNo: tanNo.toUpperCase(),
          tanFile: tanFileName || "", // Optional document
          resubmitType: "TAN",
          tanVerified: {
            status: "PENDING",
            verifiedBy: "",
          },
          // SL-828
          "tanStatus": showTanSelectBlock === "no" ? false : true,
        };
        api.seller
          .updateInfo(data)
          .then((res) => {
            // console.log(res);
            getProfileInfo();
            handleCloseverifyfield();
          })
          .catch((err) => console.log(err));
      }
    } else if (doc === "pan") {
      if (panNo === "" || panNo === undefined) {
        alert.info("Please enter a valid PAN No!");
        setshowAlert(true);
        setalertMsg("Please enter PAN no");
      } else if (panUploadProg && panUploadProg > 0) {
        alert.info("Please wait for PAN upload to complete!");
        setshowAlert(true);
        setalertMsg("Please wait for PAN upload to complete!");
      } else if (panFileName === "" || panFileName === undefined) {
        alert.info("Please upload a valid PAN File!");
        setshowAlert(true);
        setalertMsg("Please upload a valid PAN File");
      } else {
        const vali = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (vali.test(panNo.toUpperCase())) {
          let data = {
            panNo: panNo.toUpperCase(),
            panFile: panFileName,
            resubmitType: "PAN",
            panVerified: {
              status: "PENDING",
              verifiedBy: "",
            },
          };
          api.seller
            .updateInfo(data)
            .then((res) => {
              getProfileInfo();
              handleCloseverifyfield();
            })
            .catch((err) => console.log(err));
        } else {
          alert.info("Please enter a valid PAN No!");
          setshowAlert(true);
          setalertMsg("Please enter a valid PAN no");
        }
      }
    }
    else if (doc === "msme") {
      if (msmeNo === "" || msmeNo === undefined) {
        alert.info("Please enter a valid MSME No!");
        setshowAlert(true);
        setalertMsg("Please enter MSME No!");
      }
      else if (msmeUploadProg && msmeUploadProg > 0) {
        alert.info("Please wait for MSME document upload to complete!");
        setshowAlert(true);
        setalertMsg("Please wait for upload to complete!");
      }
      else if (!msmeFileName || msmeFileName === "") {
        alert.info("Please upload MSME document!");
        setshowAlert(true);
        setalertMsg("Please upload MSME document!");
      }
      else {
        let data = {
          msmeNo: msmeNo.toUpperCase(),
          msmeFile: msmeFileName,
          resubmitType: "MSME",
          msmeVerified: {
            status: "PENDING",
            verifiedBy: "",
          },
          // SL-828
          "msmeStatus": showMsmeSelectBlock === "no" ? false : true,
        };
        api.seller
          .updateInfo(data)
          .then((res) => {
            getProfileInfo();
            handleCloseverifyfield()
          })
          .catch((err) => console.log(err));

      }
    }
  }

  function recall() {
    api.auth
      .me({})
      .then((res) => {
        setresponseData(res.data);
        setgstNo(res.data.gstNo);
        settanNo(res.data.tanNo);
        setpanNo(res.data.panNo);
        setsellerdescription(res.data.description);
        if (res.data.gstVerified && res.data.gstVerified.status) {
          // setgstStatus(res.data.gstVerified.status)
        }
        if (res.data.tanVerified && res.data.tanVerified.status) {
          // settanStatus(res.data.tanVerified.status)
          console.log(res.data.tanVerified.status);
        }
        if (res.data.panVerified && res.data.panVerified.status) {
          // setpanStatus(res.data.panVerified.status)
          console.log(res.data.panVerified.status);
        }
      })
      .catch((err) => console.log(err));
  }

  // confirmation profile pic

  function confirmProfilePic(e) {
    if (!confirmPic) {
      let res = window.confirm("Do you want to change your profile picture?");
      if (res === true) {
        document.getElementById("file-upload-seller").click();
        setconfirmPic(true);
        setTimeout(() => {
          setconfirmPic(false);
        }, 500);
      }
    }
  }

  // Add address seller response

  const handleResAddress = (res, msg) => {
    if (res === "success") {
      handleAddressClose();
      alert.success("Address added successfully.");
      fetchSellerAddress(dispatch);
    } else {
      handleAddressClose();
      alert.info(msg);
    }
  };

  function downloadFile(file, docNo, type) {
    let lastDot = file.lastIndexOf(".");
    let fileType = file.substr(lastDot);
    let downloadName = docNo + "-" + type;
    let data = {
      "bucket": "seller_doc",
      "key": "mob/products/" + file
    }
    api.docs.getImage(data).then((res) => {
      const fileUrl = res.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", downloadName + fileType);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(err => console.log(err))


  }

  const showImage = async (event) => {
    seturlListshow(false);

    let isimgsSizevalid = true;
    let limit = event.target.files.length;

    if (event.target.files.length > 2) {
      limit = 2 - urlList.length;
    }

    for (let i = 0; i < limit; i++) {
      if (event.target.files[i].size > variables.limit.RegisterVendor.storePhoto) {
        isimgsSizevalid = false;
        alert.info("Please upload images of size less than or equal to 2 Mb");
        return;
      }
    }

    const newImageNames = [];

    for (let i = 0; i < limit; i++) {
      if (!GenUtilities.isFileExtensionValid(event.target.files[i].name, ['.jpg', '.jpeg', '.png'])) {
        alert.info('Please upload only valid JPG, JPEG or PNG files.');
        event.target.value = "";
        return;
      }
      const file = event.target.files[i];
      const str = file.name;
      // const extension = str.slice(str.lastIndexOf("."));
      const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
      const convertedImg = await convertFileToWebP(file);

      const imageFinal = GenUtilities.removeSpacesFromName(
        "img_" + vendorId + "_" + convertedImg.name
      );

      newImageNames.push(imageFinal);

      const data = {
        imageName: imageFinal,
        type: "products",
        bucket: "seller_doc",
      };

      try {
        const res = await servicesApi.saveImage(data);

        await axios.put(res.data, convertedImg, {
          onUploadProgress: (progressEvent) => {
            setimgprogress(Math.round((100 * progressEvent.loaded) / progressEvent.total));
          },
        });

        setimgprogress();
      } catch (error) {
        console.error(error);
      }
    }

    seturlList((prev) => [...prev, ...newImageNames]);
    seturlListshow(true);
  };

  function deleteImg(index) {
    imagesName.splice(index, 1);
    console.log(imagesName)
    seturlList([...imagesName])

  }
  function changeStep(step) {
    setStep(step);
  }
  function updateResponseData(data) {
    setresponseData({ ...data });
    getProfileInfo();
  }
  const saveStep1Data = () => {
    let registrationdata = {
      "_id": vendorId,
      gstNo: gstNo ? gstNo.toUpperCase() : "",
      gstFile: gstFileName,
      gstUpdate: true,
      gstVerified: {
        status: "PENDING",
        verifiedBy: "",
      },
      panNo: panNo ? panNo.toUpperCase() : "",
      panFile: panFileName,
      panVerified: {
        status: "PENDING",
        verifiedBy: "",
      },
      tanNo: tanNo ? tanNo.toUpperCase() : "",
      tanFile: tanFileName,
      tanVerified: {
        status: "PENDING",
        verifiedBy: "",
      },
      msmeNo: msmeNo ? msmeNo.toUpperCase() : "",
      msmeFile: msmeFileName,
      msmeVerified: {
        status: "PENDING",
        verifiedBy: "",
      },
      "businessCard": urlList,
      "sendStepsCompleteMail": true,
      "profileStepsCompleted": [
        ...responseData.profileStepsCompleted,
        {
          name: 'step1',
          value: true,
        }
      ],
      // SL-828
      "tanStatus": showTanSelectBlock === "no" ? false : true,
      "msmeStatus": showMsmeSelectBlock === "no" ? false : true
    }
    api.seller.updateInfo(registrationdata)
      .then((res) => {
        if (res.message == 'GST already added') {
          alert.info("GST already registered");
        }
        else {
          // setresponseData({...res.data});
          getProfileInfo();
          changeStep('step2');
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
  const getStepobject = (data) => {
    let compArray = responseData?.profileStepsCompleted || [];

    for (var i = 0, iLen = compArray.length; i < iLen; i++) {

      if (compArray[i].name == data) {
        return compArray[i].value;
      }
      // return false;
    }
  }

  // sl -828
  const handleStep1DisableBtnShow = () => {
    if (panNo == "" || !panSeletedFileName || gstNo == "" || !gstSeletedFileName || urlList.length == 0 || !GSTNumberValidation(gstNo) || !pancardValidation(panNo)) {
      return true;
    }
    if (showTanSelectBlock === "yes" && (tanNo === "" || tanNo === undefined || tanNo === null)) {
      return true;
    }
    if (showMsmeSelectBlock === "yes" && (msmeNo === "" || msmeNo === undefined || msmeNo === null)) {
      return true;
    }
    if (showMsmeSelectBlock === "yes" && (!msmeSeletedFileName || msmeSeletedFileName === "")) {
      return true;
    }
    if (showTanSelectBlock === null) {
      return true;
    }
    if (showMsmeSelectBlock === null) {
      return true;
    }
    if (responseData && !responseData?.emailVerified) {
      return true
    }
    return false;
  }

  const handleNotSelectedOption = async (doc) => {
    try {
      switch (doc) {
        case "TAN":
          await api.seller.updateInfo({
            "tanStatus": false
          })
          getProfileInfo();
          alert.success("Status updated.")
          return true;
        case "MSME":
          await api.seller.updateInfo({
            "msmeStatus": false
          })
          getProfileInfo();
          alert.success("Status updated.")
          return true;
        default:
          return 0;
      }
    } catch (err) {
      alert.error("Error")
    }
  }

  // Email editing functions for onboarding
  const handleEmailEdit = () => {
    setOriginalEmail(email || "");
    setTempEmail(email || "");
    setIsEmailEditing(true);
  };

  const handleEmailSave = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(tempEmail)) {
      setIsEmailEditing(false);
      setemail(tempEmail);
      // Check if email was actually changed
      if (tempEmail !== originalEmail) {
        setEmailChanged(true);
      }
    } else {
      alert.error("Please enter a valid email address");
    }
  };

  const handleEmailCancel = () => {
    setTempEmail("");
    setIsEmailEditing(false);
  };

  // Sl-997
  const handleFilePdfView = (file) => {
    console.log(file)
    let data = {
      "bucket": "seller_doc",
      "key": "mob/products/" + file
    }
    api.docs.getImage(data).then((res) => {
      const fileUrl = res.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(err => {
      console.log(err)
    })
  }

  if (isLoading) {
    return <>Loading</>;
  } else {
    return (
      <>
        <div className="profile-page" style={{ background: '#ecedef' }}>
          <div class="radio-tabs">

            {/* desktop sidebar */}
            <div class="tabs left-panel border-2  white-bg">
              <div class="profile-card white-bg w-100">
                <div className="">
                  <div className="l-n d-flex my-2 px-2 ">
                    {/* {isVerifiedSeller ? (
                      <></>
                    ) : (
                      <div className="pr-2 py-1 fs-13 text-red f-500">
                        <i className="fa fa-info-circle"></i> Profile
                        verification pending
                      </div>
                    )} */}
                    <div class="dis-flex">
                      {sellerPic ? (
                        <div className="profile-pic">
                          <img
                            src={
                              "https://s3.toolsvilla.com/mob/avatar/" +
                              sellerPic
                            }
                            alt="img"
                          />
                        </div>
                      ) : (
                        <div className="profile-pic">
                          <img
                            src="./user.png"
                            alt="user"
                          />
                        </div>
                      )}
                      <div className="">
                        <span className="user-name">{responseData?.name}</span>
                        <br />
                        <span
                          style={{
                            cursor: 'pointer',
                            color: 'white',
                            background: "teal",
                            padding: "2px 8px",
                            borderRadius: "4px",

                          }}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          Change Profile Picture
                        </span>
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                            changeSellerPic(e)
                          }}
                        />
                      </div>

                      {/* <div>
                      <i
                        className="bi bi-pencil-square edit-seller-img"
                        onClick={(e) => confirmProfilePic(e)}
                      ></i>
                    </div> */}
                    </div>
                  </div>
                </div>{" "}
              </div>

              <div className="white-bg profile-card border-2">
                <div className="profile-menu-heading">
                  {" "}
                  <img src="/profile.webp" alt="img" className="px-1 w-15 mx-1" />
                  ACCOUNT SETTINGS
                </div>
                <label for="radio1" onClick={() => setStep('step1')} id="first-tab" class={`tab profile-menu ${step == 'step1' ? 'profile-tab-active' : ""}`}>
                  <div class="tab-label dis-flex justify-content-between">Personal Information
                    <img src={`/step-${getStepobject('step1') ? 'done' : "pending"}.webp`} class="menu-icon" alt="icon" /></div>
                </label>

                <label for="radio2" onClick={() => setStep('step2')} id="second-tab" class={`tab profile-menu ${step == 'step2' ? 'profile-tab-active' : ""}`}>
                  <div class="tab-label profile-menu dis-flex justify-content-between">Manage Addresses
                    <img src={`/step-${responseData.active || responseData?.gAddress?.address ? 'done' : "pending"}.webp`} class="menu-icon" alt="icon" />
                  </div>
                </label>

                <label for="radio3" onClick={() => setStep('step3')} id="third-tab" class={`tab profile-menu ${step == 'step3' ? 'profile-tab-active' : ""}`}>
                  <div class="tab-label profile-menu dis-flex justify-content-between">Bank Details
                    <img src={`/step-${responseData?.bankDetail?.acno ? 'done' : "pending"}.webp`} class="menu-icon" alt="icon" />
                  </div>
                </label>

                <label for="radio3" onClick={() => setStep('step4')} id="third-tab" class={`tab profile-menu ${step == 'step4' ? 'profile-tab-active' : ""}`}>
                  <div class="tab-label profile-menu dis-flex justify-content-between">Agreement Document
                    <img src={`/step-${responseData?.agreementVerified?.status === "APPROVED" ? 'done' : "pending"}.webp`} class="menu-icon" alt="icon" />
                  </div>
                </label>
                {/* {responseData?.active &&
                  <label for="radio4" onClick={() => setStep('step5')} id="fourth-tab" class={`tab profile-menu ${step == 'step5' ? 'profile-tab-active' : ""}`}>
                    <div class="tab-label profile-menu dis-flex justify-content-between">Seller support</div>

                  </label>} */}


                <label for="radio4" onClick={() => setStep('step8')} id="fourth-tab" class={`tab profile-menu ${step == 'step8' ? 'profile-tab-active' : ""}`}>
                  <div class="tab-label profile-menu dis-flex justify-content-between">Legal & Policies</div>
                </label>

              </div>

              {/* <div className="profile-card white-bg" style={{marginTop: '2px'}}>
                {responseData?.active&&
              <><div className="profile-menu-heading">
                    <span>
                      {" "}
                      <img
                        src="/wallet.webp"
                        alt="img"
                        className="px-1 w-15  mx-1" />
                    </span>
                    <span className="pt-1">PAYMENT</span>
                  </div><label for="radio5" onClick={() => setStep('step6')} id="fifth-tab" class={`tab profile-menu ${step == 'step6' ? 'profile-tab-active' : ""}`}>
                      <div class="tab-label profile-menu dis-flex justify-content-between">TV Wallet</div>
                    </label><label for="radio6" onClick={() => setStep('step7')} id="sixth-tab" class={`tab profile-menu ${step == 'step7' ? 'profile-tab-active' : ""}`}>
                      <div class="tab-label profile-menu dis-flex justify-content-between">Linked Accounts</div>
                    </label></>}
              </div> */}
              {/* <label for="radio5" id="fifth-tab" class="tab">
                <div class="tab-label">TV Wallet</div>
              </label>
              <label for="radio6" id="sixth-tab" class="tab">
                <div class="tab-label">Legal and Policies</div>
              </label> */}

              <input
                type="file"
                onChange={(e) => changeSellerPic(e)}
                id="file-upload-seller"
                className="input_pic_profile"
                accept=".jpg, .jpeg, .png"
              />
            </div>

            <div className="panels profile-panel">
              {!responseData.active && <ProfileStepsTab profile={responseData} step={step} />}
              {/* First panel */}
              {step == 'step1' &&
                <div>
                  <Card className="card-box">
                    <div className="d-flex my-3 theme-shed1 p-2 mt-2 flex-direction-column">
                      <div className="pr-2 w-sm-100">
                        <div className="input-lable">Name</div>
                        <input
                          type="text"
                          name="name"
                          className="name-cast"
                          id="name-s"
                          value={responseData?.name}
                          onChange={(e) => setname(e.target.value)}
                          readOnly={true}
                        />
                      </div>
                      {responseData && responseData.emailVerified ?
                        <div className="rl-border">
                          <div className="input-lable">Email Address</div>
                          <div className="email-container">

                            <div className="input-container">
                              <div>
                                <input
                                  type="text"
                                  name="email"
                                  className={`name-cast`}
                                  value={email}
                                  id="email-s"
                                  readOnly={true}
                                />

                              </div>
                              {responseData.active && <button className="profile-but" onClick={() => { setChangeEmail(true); setChangeType('email') }}>Change</button>}
                            </div>


                          </div>
                          {/* <div className="fs-13">{email}</div> */}
                        </div> :
                        <div className="rl-border">
                          <div className="input-lable">Email Address<sup style={{ color: 'red' }}>*</sup></div>
                          <div className="email-container">

                            <div className="input-container">
                              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <input
                                  type="text"
                                  name="email"
                                  className={`name-cast ${!responseData.email || responseData.email == "" ? "white-bg" : ""} ${isEmailEditing ? "white-bg" : ""}`}
                                  value={isEmailEditing ? tempEmail : email}
                                  onChange={(e) => {
                                    if (isEmailEditing) {
                                      setTempEmail(e.target.value);
                                    } else {
                                      setemail(e.target.value);
                                    }
                                  }}
                                  id="email-s"
                                  placeholder="Enter your email"
                                  readOnly={!isEmailEditing && (email && email !== "")}
                                  style={{ paddingRight: '31px' }}
                                />
                                {!isEmailEditing && email && email !== "" && (
                                  <i
                                    className="fa fa-edit"
                                    style={{
                                      position: 'absolute',
                                      right: '10px',
                                      cursor: 'pointer',
                                      color: '#6D6D6D'
                                    }}
                                    onClick={handleEmailEdit}
                                    title="Edit email"
                                  ></i>
                                )}
                                {isEmailEditing && (
                                  <i
                                    className="fa fa-save"
                                    style={{
                                      position: 'absolute',
                                      right: '10px',
                                      cursor: 'pointer',
                                      color: '#28a745'
                                    }}
                                    onClick={handleEmailSave}
                                    title="Save email"
                                  ></i>
                                )}
                              </div>
                              <button className="profile-but" onClick={() => {
                                if (email && email.trim() !== "") {
                                  setVerifyEmailShow(true);
                                } else {
                                  alert.error("Please enter an email address first");
                                }
                              }}>Verify</button>
                            </div>

                          </div>
                          {/* Email Verification Error - Show directly below email input when not verified */}
                          {responseData && !responseData?.emailVerified ? (
                            <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                              Please verify your email address to continue
                            </div>
                          ) : ""}
                          <VerifyEmailModal
                            show={verifyEmailShow}
                            data={responseData}
                            handleClose={() => {
                              setVerifyEmailShow(false);
                              setEmailChanged(false); // Reset email changed flag after closing modal
                            }}
                            updateInfo={() => getProfileInfo()}
                            newEmail={email}
                            emailChanged={emailChanged}
                          />
                        </div>
                      }

                      <div className="relative ms-2 p-sm-0 m-sm-0">
                        <div className="input-lable">Mobile Number</div>
                        <div className="email-container">

                          <div className="input-container">
                            <div className="relative">
                              <label for="phone-s" className="phonePrefix">+91 | </label>
                              <input
                                type="text"
                                name="phone"
                                className={`name-cast pl-50 ${changePhone ? "white-bg" : ""}`}
                                value={phone}
                                id="phone-s"
                                // onChange={(e) => checkPhoneChange(e.target.value)}
                                readOnly={!changePhone}
                              />

                            </div>
                            {responseData.active && <button className="profile-but" onClick={() => { setChangeEmail(true); setChangeType('phone') }}>Change</button>}
                          </div>

                        </div>
                      </div>
                    </div>

                    {/* Gst NO */}
                    <div className="theme-shed1 p-2">
                      {/* <ul className="d-flex l-n px-1 mb-0  pt-2 pb-1">
                      <li className="mx-3">
                        <h6 className="ff_pop text-dark">GST Number</h6>
                      </li>
                    </ul> */}
                      <div className="document-upload flex-direction-column">
                        <div className="title">GST Number<sup>*</sup></div>
                        <div className="textbox">
                          {/* {gstStatus === "REJECTED" ? (
                        <p className="text-danger mx-3 profile_tips_msgs">
                          Please re-submit your GST details !
                        </p>
                      ) : gstStatus === "PENDING" ? (
                        <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                          GST document verification in process.<br></br>
                        </span>
                      ) : (
                        <></>
                      )} */}
                          <input
                            type="text"
                            name="gst"
                            className="name-cast"
                            placeholder="Please enter GST number"
                            onChange={(e) => setgstNo(e.target.value)}
                            value={gstNo}
                            readOnly={responseData.gstNo ? true : false}
                            id="gst"
                          />
                        </div>
                        {gstStatus === "REJECTED" ? (
                          <>
                            <span className="text-danger ff_pop fs-12">
                              {" "}
                              ❌ rejected
                            </span>
                            <button
                              className="profile-submit"
                              onClick={() => handleShowverifyfield("GST")}
                            >
                              Resubmit
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        {!responseData?.gstNo ? (
                          <><div className="upload-box">
                            <div className="placeholder-text">

                              {gstUploadProg ? (
                                <ProgressBar
                                  id="progress-B"
                                  now={gstUploadProg}
                                  label={`${gstUploadProg}%`}
                                />
                              ) : gstSeletedFileName ? gstSeletedFileName : "Upload Document..."}
                            </div>
                            <label
                              for="gstInput"
                              className="profile_resubmit_btn"
                            // onClick={() => handleShowverifyfield("GST")}
                            >
                              {gstSeletedFileName ? "Change" : "Upload"}
                            </label>
                            <input
                              type="file"
                              hidden
                              accept="image/*,.pdf"
                              onChange={(e) => uploadGst(e)}
                              onClick={(event) => {
                                event.target.value = null
                              }}
                              className="ff_pop"
                              id="gstInput"
                            ></input>
                          </div><div className="button">
                              <button type="button" onClick={() => resubmitdoc("gst")}>Submit</button>
                            </div></>
                        ) : (
                          <>
                            {gstStatus === "REJECTED" ? (
                              <p className="text-danger mx-3 profile_tips_msgs">
                                Please re-submit your GST details !
                              </p>
                            ) : gstStatus === "PENDING" ? (
                              <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                                <div className="d-flex align-items-center">

                                  {
                                    responseData.gstFile && responseData.gstFile.split(".")[responseData.gstFile.split(".").length - 1] == 'pdf' ?
                                      <><div className="view-icon" onClick={() => handleFilePdfView(responseData.gstFile)}>
                                        <img src="/view-icon.webp" alt="icon" />
                                      </div>
                                        <div
                                          className="view-doc cursor-pointer"
                                          onClick={() => handleFilePdfView(responseData.gstFile)}
                                        >
                                        </div></>
                                      :
                                      <><div className="view-icon" onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.gstFile); }}>
                                        <img src="/view-icon.webp" alt="icon" />
                                      </div><div
                                        className="view-doc cursor-pointer"
                                        onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.gstFile); }}
                                      >
                                          View Document
                                        </div></>
                                  }
                                  <div className="px-2">GST document verification in process.</div>
                                </div>
                              </span>
                            ) : (
                              <div className="doc-name">{responseData?.gstFile}</div>
                            )}
                          </>
                        )}
                        {gstStatus === "APPROVED" ? (
                          <span className="text-success ff_pop fs-12">
                            <i className="bi bi-patch-check-fill text-success ms-2"></i>{" "}
                            verified
                          </span>
                        ) : (
                          <></>
                        )}
                        {responseData?.gstFile && gstStatus === "APPROVED" ? (
                          <a
                            href="javascript:void(0)"
                            className="ff_pop fs-12 ms-2"
                            onClick={() =>
                              downloadFile(
                                responseData?.gstFile,
                                responseData?.gstNo,
                                "gst"
                              )
                            }
                          >
                            <i class="fa fa-download" aria-hidden="true"></i>{" "}
                            Download Document
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* Show combined validation errors for GST */}
                    {(!gstNo || gstNo === "") && (!gstSeletedFileName || gstSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        GST number and document are required
                      </div>
                    ) : (!gstNo || gstNo === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        GST number is required
                      </div>
                    ) : !GSTNumberValidation(gstNo) ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        Please enter a valid GST number
                      </div>
                    ) : (!gstSeletedFileName || gstSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        GST document is required
                      </div>
                    ) : ""}

                    {/* Pan NO */}
                    <div className="theme-shed1 p-2">
                      <div className="document-upload flex-direction-column">
                        <div className="title">PAN Number<sup>*</sup></div>
                        <div className="textbox">
                          <input
                            type="text"
                            name="phone"
                            className="name-cast"
                            placeholder="Please enter PAN number"
                            // value={panNo}
                            onChange={(e) => setpanNo(e.target.value)}
                            value={panNo}
                            readOnly={responseData.panNo ? true : false}
                            id="phone"
                          /></div>
                        {panStatus === "REJECTED" ? (
                          <>
                            <span className="text-danger ff_pop fs-12">
                              {" "}
                              ❌ rejected
                            </span>
                            <button
                              className="profile-submit"
                              onClick={() => handleShowverifyfield("PAN")}
                            >
                              Resubmit
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        {!responseData?.panNo || responseData?.panNo === "" ? (
                          <><div className="upload-box">
                            <div className="placeholder-text">
                              {panUploadProg ? (
                                <ProgressBar
                                  id="progress-B"
                                  now={tanUploadProg}
                                  label={`${tanUploadProg}%`}
                                />
                              ) : panSeletedFileName ? panSeletedFileName : "Upload Document..."}
                            </div>
                            <label
                              for="panInput"
                              className="profile_resubmit_btn"
                            >
                              {panSeletedFileName ? "Change" : "Upload"}
                            </label>
                            <input
                              type="file"
                              hidden
                              accept="image/*,.pdf"
                              onChange={(e) => uploadPan(e)}
                              onClick={(event) => {
                                event.target.value = null
                              }}
                              className="ff_pop"
                              id="panInput"
                            ></input>
                          </div><div className="button">
                              <button type="button" onClick={() => resubmitdoc("pan")}>Submit</button>
                            </div></>

                        ) : (
                          <>
                            {panStatus === "REJECTED" ? (
                              <p className="text-danger mx-3 profile_tips_msgs">
                                Please re-submit your PAN details !
                              </p>
                            ) : panStatus === "PENDING" ? (
                              <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                                <div className="d-flex align-items-center">

                                  {
                                    responseData.panFile && responseData.panFile.split(".")[responseData.panFile.split(".").length - 1] == 'pdf' ?
                                      <><div className="view-icon" onClick={() => {
                                        handleFilePdfView(responseData?.panFile)
                                      }}>
                                        <img src="/view-icon.webp" alt="icon" />
                                      </div>
                                        <div
                                          className="view-doc cursor-pointer"
                                          onClick={() => {
                                            handleFilePdfView(responseData?.panFile)
                                          }}
                                        >
                                          View Document
                                        </div></>
                                      :
                                      <><div className="view-icon" onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.panFile); }}>
                                        <img src="/view-icon.webp" alt="icon" />
                                      </div><div
                                        className="view-doc cursor-pointer"
                                        onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.panFile); }}
                                      >
                                          View Document
                                        </div></>
                                  }
                                  <div className="px-2">PAN document verification in process.</div>
                                </div>

                              </span>
                            ) : (
                              <div className="doc-name">{responseData?.panFile}</div>
                            )}
                          </>
                        )}
                        {panStatus === "APPROVED" ? (
                          <span className="text-success ff_pop fs-12">
                            <i className="bi bi-patch-check-fill text-success ms-2"></i>{" "}
                            verified
                          </span>
                        ) : (
                          <></>
                        )}
                        {responseData?.panFile && panStatus === "APPROVED" ? (
                          <a
                            href="javascript:void(0)"
                            className="ff_pop fs-12 ms-2"
                            onClick={() =>
                              downloadFile(
                                responseData?.panFile,
                                responseData?.panNo,
                                "pan"
                              )
                            }
                          >
                            <i class="fa fa-download" aria-hidden="true"></i>{" "}
                            Download Document
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* Show combined validation errors for PAN */}
                    {(!panNo || panNo === "") && (!panSeletedFileName || panSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        PAN number and document are required
                      </div>
                    ) : (!panNo || panNo === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        PAN number is required
                      </div>
                    ) : !pancardValidation(panNo) ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        Please enter a valid PAN number
                      </div>
                    ) : (!panSeletedFileName || panSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        PAN document is required
                      </div>
                    ) : ""}
                    {/* Tan NO */}
                    {/* sl-828(838) */}
                    {showTanQues ? <div className="theme-shed1 p-2 msme-select-block">
                      <label>Do you have TAN Number?<span style={{ color: 'red' }}>*</span></label>
                      <input type="radio" name="tan" checked={showTanSelectBlock === "yes"} onChange={() => handleTanSelection('yes')} /> Yes
                      <input type="radio" name="tan" checked={showTanSelectBlock === "no"} onChange={() => handleTanSelection('no')} /> No
                      {showTanSelectBlock === "no" && getStepobject('step1') && !('tanStatus' in responseData) && <button
                        className="profile-submit ms-1"
                        onClick={() => handleNotSelectedOption("TAN")}
                      >
                        Submit
                      </button>}
                      {/* {
                        !('tanStatus' in responseData) && showTanSelectBlock === null && <div className="validation-error px-2">
                          Please select any one of two options for TAN.
                        </div>
                      } */}
                    </div> : <></>}

                    {showTanSelectBlock === "yes" ? <div className="theme-shed1 p-2">
                      <div className="document-upload flex-direction-column">
                        <div className="title">TAN Number<sup>*</sup></div>

                        <div className="textbox">
                          {/* {tanStatus === "REJECTED" ? (
                        <p className="text-danger mx-3 profile_tips_msgs">
                          Please re-submit your TAN details !
                        </p>
                      ) : tanStatus === "PENDING" ? (
                        <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                          TAN document verification in process.<br></br>
                        </span>
                      ) : (
                        <></>
                      )} */}
                          <input
                            type="text"
                            name="phone"
                            className="name-cast"
                            placeholder="Please enter TAN number"
                            // value={tanNo}
                            onChange={(e) => settanNo(e.target.value)}
                            value={tanNo}
                            readOnly={responseData.tanNo ? true : false}
                            id="phone"
                          />
                        </div>
                        {tanStatus === "REJECTED" ? (
                          <>
                            <span className="text-danger ff_pop fs-12">
                              {" "}
                              ❌ rejected
                            </span>
                            <button
                              className="profile-submit"
                              onClick={() => handleShowverifyfield("TAN")}
                            >
                              Resubmit
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        {!responseData?.tanNo ? (
                          <><div className="upload-box">
                            <div className="placeholder-text">

                              {tanUploadProg ? (
                                <ProgressBar
                                  id="progress-B"
                                  now={tanUploadProg}
                                  label={`${tanUploadProg}%`}
                                />
                              ) : tanSeletedFileName ? tanSeletedFileName : "Upload Document..."}
                            </div>
                            <label
                              for="tanInput"
                              className="profile_resubmit_btn"
                            // onClick={() => handleShowverifyfield("TAN")}
                            >
                              {tanSeletedFileName ? "Change" : "Upload"}
                            </label>
                            <input
                              type="file"
                              hidden
                              accept="image/*,.pdf"
                              onChange={(e) => uploadTan(e)}
                              onClick={(event) => {
                                event.target.value = null
                              }}
                              className="ff_pop"
                              id="tanInput"
                            ></input>
                          </div><div className="button">
                              <button type="button" onClick={() => resubmitdoc("tan")}>Submit</button>
                            </div></>
                        ) : (
                          <>
                            {responseData?.tanFile ? (
                              // Case: TAN number + document submitted - show document status
                              <>
                                {tanStatus === "REJECTED" ? (
                                  <p className="text-danger mx-3 profile_tips_msgs">
                                    Please re-submit your TAN details !
                                  </p>
                                ) : tanStatus === "PENDING" ? (
                                  <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                                    <div className="d-flex align-items-center">
                                      {responseData.tanFile.split(".")[responseData.tanFile.split(".").length - 1] == 'pdf' ? (
                                        <>
                                          <div className="view-icon" onClick={() => {
                                            handleFilePdfView(responseData?.tanFile)
                                          }}>
                                            <img src="/view-icon.webp" alt="icon" />
                                          </div>
                                          <div className="view-doc cursor-pointer" onClick={() => {
                                            handleFilePdfView(responseData?.tanFile)
                                          }}>
                                            View Document
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="view-icon" onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.tanFile); }}>
                                            <img src="/view-icon.webp" alt="icon" />
                                          </div>
                                          <div className="view-doc cursor-pointer" onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.tanFile); }}>
                                            View Document
                                          </div>
                                        </>
                                      )}
                                      <div className="px-2">TAN document verification in process.</div>
                                    </div>
                                  </span>
                                ) : (
                                  <div className="doc-name">{responseData?.tanFile}</div>
                                )}
                              </>
                            ) : (
                              // Case: Only TAN number submitted (no document)
                              <div className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                                TAN number submitted
                              </div>
                            )}
                          </>
                        )}
                        {tanStatus === "APPROVED" ? (
                          <span className="text-success ff_pop fs-12">
                            <i className="bi bi-patch-check-fill text-success ms-2"></i>{" "}
                            verified
                          </span>
                        ) : (
                          <></>
                        )}
                        {responseData?.tanFile && tanStatus === "APPROVED" ? (
                          <a
                            href="javascript:void(0)"
                            className="ff_pop fs-12 ms-2"
                            onClick={() =>
                              downloadFile(
                                responseData?.tanFile,
                                responseData?.tanNo,
                                "tan"
                              )
                            }
                          >
                            <i class="fa fa-download" aria-hidden="true"></i>{" "}
                            Download Document
                          </a>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div> : <></>}
                    {/* Show only ONE validation error for TAN - Priority: Selection mandatory > Number required */}
                    {(showTanSelectBlock === null || showTanSelectBlock === undefined || showTanSelectBlock === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        TAN selection is mandatory
                      </div>
                    ) : showTanSelectBlock === "yes" && (!tanNo || tanNo === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        TAN number is required
                      </div>
                    ) : ""}

                    {/* sl-663 */}
                    {/* MSME */}
                    {showMsmeQues ? <div className="theme-shed1 p-2 msme-select-block">
                      <label>Are you MSME registered?<span style={{ color: 'red' }}>*</span></label>
                      <input type="radio" name="msme" checked={showMsmeSelectBlock === "yes"} onChange={() => handleMsmeSelection('yes')} /> Yes
                      <input type="radio" name="msme" checked={showMsmeSelectBlock === "no"} onChange={() => handleMsmeSelection('no')} /> No
                      {showMsmeSelectBlock === "no" && getStepobject('step1') && !('msmeStatus' in responseData) && <button
                        className="profile-submit ms-1"
                        onClick={() => handleNotSelectedOption("MSME")}
                      >
                        Submit
                      </button>}
                    </div> : <></>}
                    {/* 
                    {
                      !('msmeStatus' in responseData) && showMsmeSelectBlock === null && <div className="validation-error px-2">
                        Please select any one of two options for MSME.
                      </div>
                    } */}

                    {showMsmeSelectBlock === "yes" && (
                      <>
                        <div className="theme-shed1 p-2">
                          <div className="document-upload flex-direction-column">
                            <div className="title">MSME Number<sup>*</sup></div>
                            <div className="textbox">
                              <input
                                type="text"
                                name="phone"
                                className="name-cast"
                                placeholder="Please enter MSME number"
                                onChange={(e) => setMsmeNo(e.target.value)}
                                value={msmeNo}
                                readOnly={responseData.msmeNo ? true : false}
                                id="phone"
                              />
                            </div>
                            {msmeStatus === "REJECTED" ? (
                              <>
                                <span className="text-danger ff_pop fs-12">
                                  {" "}
                                  ❌ rejected
                                </span>
                                <button
                                  className="profile-submit"
                                  onClick={() => handleShowverifyfield("MSME")}
                                >
                                  Resubmit
                                </button>
                              </>
                            ) : (
                              <></>
                            )}
                            {!responseData?.msmeNo || responseData?.msmeNo === "" ? (
                              <><div className="upload-box">
                                <div className="placeholder-text">

                                  {msmeUploadProg ? (
                                    <ProgressBar
                                      id="progress-B"
                                      now={msmeUploadProg}
                                      label={`${msmeUploadProg}%`}
                                    />
                                  ) : msmeSeletedFileName ? msmeSeletedFileName : "Upload Document..."}
                                </div>
                                <label
                                  for="msmeInput"
                                  className="profile_resubmit_btn"
                                >
                                  {msmeSeletedFileName ? "Change" : "Upload"}
                                </label>
                                <input
                                  type="file"
                                  hidden
                                  accept="image/*,.pdf"
                                  onChange={(e) => uploadMsme(e)}
                                  onClick={(event) => {
                                    event.target.value = null
                                  }}
                                  className="ff_pop  profile-input"
                                  id="msmeInput"
                                ></input>
                              </div><div className="button">
                                  <button type="button" onClick={() => resubmitdoc("msme")}>Submit</button>
                                </div></>
                            ) : (
                              <>
                                {msmeStatus === "REJECTED" ? (
                                  <p className="text-danger mx-3 profile_tips_msgs">
                                    Please re-submit your MSME details !
                                  </p>
                                ) : msmeStatus === "PENDING" ? (
                                  <span className="profile_tips_msgs_pending mx-3 profile_tips_msgs">
                                    <div className="d-flex align-items-center">

                                      {
                                        responseData.msmeFile && responseData.msmeFile.split(".")[responseData.msmeFile.split(".").length - 1] == 'pdf' ?
                                          <><div className="view-icon" onClick={() => {
                                            handleFilePdfView(responseData?.tanFile)
                                          }}>
                                            <img src="/view-icon.webp" alt="icon" />
                                          </div>
                                            <div
                                              className="view-doc cursor-pointer"
                                              onClick={() => {
                                                handleFilePdfView(responseData?.tanFile)
                                              }}
                                            >
                                              View Document
                                            </div></>
                                          :
                                          <><div className="view-icon" onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.msmeFile); }}>
                                            <img src="/view-icon.webp" alt="icon" />
                                          </div><div
                                            className="view-doc cursor-pointer"
                                            onClick={() => { setDocViewShow(true); setDocumentViewFile(responseData.msmeFile); }}
                                          >
                                              View Document
                                            </div></>
                                      }
                                      <div className="px-2">MSME document verification in process.</div>
                                    </div>
                                  </span>
                                ) : (
                                  <div className="doc-name">{responseData?.msmeFile}</div>
                                )}
                              </>
                            )}
                            {msmeStatus === "APPROVED" ? (
                              <span className="text-success ff_pop fs-12">
                                <i className="bi bi-patch-check-fill text-success ms-2"></i>{" "}
                                verified
                              </span>
                            ) : (
                              <></>
                            )}
                            {responseData?.msmeFile && msmeStatus === "APPROVED" ? (
                              <a
                                href="javascript:void(0)"
                                className="ff_pop fs-12 ms-2"
                                onClick={() =>
                                  downloadFile(
                                    responseData?.msmeFile,
                                    responseData?.msmeNo,
                                    "tan"
                                  )
                                }
                              >
                                <i class="fa fa-download" aria-hidden="true"></i>{" "}
                                Download Document
                              </a>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {/* Show combined validation errors for MSME - Priority: Selection mandatory > Number and document required > Individual errors */}
                    {(showMsmeSelectBlock === null || showMsmeSelectBlock === undefined || showMsmeSelectBlock === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        MSME selection is mandatory
                      </div>
                    ) : showMsmeSelectBlock === "yes" && (!msmeNo || msmeNo === "") && (!msmeSeletedFileName || msmeSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        MSME number and document are required
                      </div>
                    ) : showMsmeSelectBlock === "yes" && (!msmeNo || msmeNo === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        MSME number is required
                      </div>
                    ) : showMsmeSelectBlock === "yes" && (!msmeSeletedFileName || msmeSeletedFileName === "") ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        MSME document is required
                      </div>
                    ) : ""}

                    <div className="add-image-container p-2">
                      <div className="title">
                        <div>Attach Store Photo<sup>*</sup></div>
                        <div className="light">(Maximum 2 Photos)</div>
                      </div>
                      <div className="dis-flex">
                        {urlListshow === true ? storePhotos.map((item, index) => {
                          return (
                            <div className="image-inner block">
                              <lable for="store-photo block">
                                <span className='p-r block'
                                ><img src={item} key={index} height="46" className='add-upload-desk w-100'></img>
                                  {!getStepobject('step1') && <span className='cross top-n-24 cursor-pointer' onClick={() => deleteImg(index)}>x</span>}</span>
                              </lable>
                            </div>

                          )
                        }) : <></>}
                        {/* Show placeholders for remaining slots */}
                        {Array.from({ length: 2 - urlList.length }, (_, index) => (
                          <div className="image-inner" key={`placeholder-${index}`}>
                            <label for="store-photo">
                              <img src="dummy-add-image.webp" alt="add-image" class=" cursor-pointer" />
                            </label>
                            <input type="file" multiple accept="image/*" hidden id="store-photo" onChange={(e) => showImage(e)} />
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Show default validation error for store photo */}
                    {(!urlList || urlList.length === 0) ? (
                      <div className="validation-error px-2" style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                        Store photo is required
                      </div>
                    ) : ""}
                    {/* {responseData && responseData.emailVerified? */}
                    <>
                      {!getStepobject('step1') && <div className="text-center mb-4">
                        {handleStep1DisableBtnShow() ?
                          <button className="profile-submit profile-submit-disable" onClick={() => setDocError(true)}>Submit & Next</button> :
                          <button className="button-style" onClick={() => saveStep1Data()}>Submit & Next</button>
                        }
                      </div>}
                    </>
                    {/* :
                  <div className="text-center mb-4">
                  <button className="button-style" onClick={()=>alert.info("Verify your email to proceed further")}>Submit & Next</button>
                  </div>
                } */}
                  </Card>
                  <PersonalInfoChange show={changeEmail} data={responseData} handleClose={() => setChangeEmail(false)} type={changeType} updateInfo={() => getProfileInfo()} />
                  {/* Modal for resubmitting gst/tan */}

                  <Modal
                    show={showverifyfield}
                    onHide={handleCloseverifyfield}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {showAlert ? (
                        <Alert variant="danger" className="p-1">
                          {alertMsg} !
                        </Alert>
                      ) : (
                        <></>
                      )}
                      {currVerPopup === "GST" ? (
                        <>
                          <div>
                            <p className="ff_pop fs-12">GST NO.</p>
                            <input
                              type="text"
                              className="pl-1 profile-input"
                              onChange={(e) => setgstNo(e.target.value)}
                              value={gstNo}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="f-700 ff_pop fs-12">Attach GST Document *:</p>
                            {gstUploadProg && (
                              <ProgressBar
                                id="progress-B"
                                now={gstUploadProg}
                                label={`${gstUploadProg}%`}
                              />
                            )}
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) => uploadGst(e)}
                              className="ff_pop profile-input"
                              id="gstInput"
                            ></input>
                          </div>
                          <div className="text-center">
                            <button
                              className="profile-submit mt-3 text-center"
                              onClick={() => resubmitdoc("gst")}
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      ) : currVerPopup === "TAN" ? (
                        <>

                          <div>
                            <p className="fs-12">TAN NO.</p>
                            <input
                              type="text"
                              className="pl-1 ff_pop  profile-input"
                              onChange={(e) => settanNo(e.target.value)}
                              value={tanNo}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="f-700 ff_pop fs-12">Attach TAN Document *:</p>
                            {responseData?.tanFile && (
                              <div className="mb-2 p-2" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                                <small className="text-muted">Current file: </small>
                                <span className="fs-12">{responseData.tanFile}</span>
                              </div>
                            )}
                            {tanUploadProg && (
                              <ProgressBar
                                id="progress-B"
                                now={tanUploadProg}
                                label={`${tanUploadProg}%`}
                              />
                            )}
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) => uploadTan(e)}
                              className="ff_pop profile-input"
                              id="tanInput"
                            ></input>
                          </div>
                          <div className="text-center">
                            <button
                              className="profile-submit mt-3 text-center"
                              onClick={() => resubmitdoc("tan")}
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      ) : currVerPopup === "PAN" ? (
                        <>

                          <div>
                            <p className="fs-12">PAN NO.</p>
                            <input
                              type="text"
                              className="pl-1 ff_pop  profile-input"
                              onChange={(e) => setpanNo(e.target.value)}
                              value={panNo}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="f-700 fs-12 ff_pop">Attach PAN Document *:</p>
                            {panUploadProg && (
                              <ProgressBar
                                id="progress-B"
                                now={panUploadProg}
                                label={`${panUploadProg}%`}
                              />
                            )}
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) => uploadPan(e)}
                              className="ff_pop  profile-input"
                              id="panInput"
                            ></input>
                          </div>
                          <div className="text-center">
                            <button
                              className="profile-submit mt-3 text-center"
                              onClick={() => resubmitdoc("pan")}
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      ) : currVerPopup === "MSME" ?
                        <>

                          <div>
                            <p className="fs-12">MSME NO.</p>
                            <input
                              type="text"
                              className="pl-1 ff_pop  profile-input"
                              onChange={(e) => setMsmeNo(e.target.value)}
                              value={msmeNo}
                            />
                          </div>
                          <div className="mt-2">
                            <p className="f-700 fs-12 ff_pop">Attach MSME Document *:</p>
                            {msmeUploadProg && (
                              <ProgressBar
                                id="progress-B"
                                now={msmeUploadProg}
                                label={`${msmeUploadProg}%`}
                              />
                            )}
                            <input
                              type="file"
                              accept="image/*,.pdf"
                              onChange={(e) => uploadMsme(e)}
                              className="ff_pop  profile-input"
                              id="msmeInput"
                            ></input>
                          </div>
                          <div className="text-center">
                            <button
                              className="profile-submit mt-3 text-center"
                              onClick={() => resubmitdoc("msme")}
                            >
                              Submit
                            </button>
                          </div>
                        </> : <></>
                      }
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>

                  {/* document view modal */}

                  <Modal
                    className="custom-modal"
                    centered
                    show={docViewShow}
                    onHide={() => setDocViewShow(false)}
                  >
                    <Modal.Body className="d-flex align-items-center justify-content-center">
                      {!documentViewFile || documentViewFile === '' || documentViewFile === null || documentViewFile === undefined ?
                        <div>No Document Available</div> :
                        <img
                          src={documentViewFile}
                          alt="document"
                          className="img-responsive img-fluid"
                        />
                      }

                    </Modal.Body>
                  </Modal>

                </div>
              }

              {/* Second panel */}
              {step == 'step2' &&
                <div >
                  {isaddressTabLoading ? (
                    <>Loading</>
                  ) : (
                    <div>
                      {responseData.active || responseData?.gAddress?.address ?
                        <Card className="m-1 card-box text-dark p-2">
                          <div className="line-gap ms-3">
                            <p className="theme-col fs-15 fw-bold">
                              <i className="bi bi-person-fill text-yellow"></i>{" "}
                              {responseData?.name}
                            </p>
                            <p className="fs-14">
                              <i className="bi bi-envelope-fill text-primary"></i>{" "}
                              {responseData?.email}
                            </p>
                            <p className="fs-13">
                              <i className="bi bi-telephone-fill text-success"></i>{" "}
                              {responseData?.phoneNumber}
                            </p>
                            <p className="fs-12">
                              <i className="bi bi-geo-alt-fill text-danger"></i>{" "}
                              {responseData?.city}
                            </p>
                            <p className="fs-11">
                             <i className="bi bi-journals"></i> {""}
                             {responseData?.gstNo}
                            </p>
                            {/* <button
                          className="manage-address"
                          onClick={() => setaddressshow(true)}
                        >
                          + Add New Address
                        </button> */}
                          </div>
                          <div className="profile_add_cntn_13">
                            {sellerAddress.length > 0 ? (
                              sellerAddress.map((item, index) => {
                                return (
                                  <div className="second-info mt-1 w-30 w-xs-50 h-auto profile_add_card">
                                    <p className="theme-col fs-15 fw-bold">
                                      <i className="bi bi-person-fill text-yellow"></i>{" "}
                                      {item.firstName}
                                    </p>
                                    <p className="fs-13">
                                      <i className="bi bi-envelope-fill text-primary"></i>{" "}
                                      {item.email}
                                    </p>
                                    <p className="fs-12">
                                      <i className="bi bi-telephone-fill text-success"></i>{" "}
                                      {item.phoneNumber}
                                    </p>
                                    {item?.gstNo && (
                                      <p className="fs-12">
                                        <i className="bi bi-journals"></i>{""}
                                        {item?.gstNo}
                                      </p>
                                    )}
                                    <p className="fs-11">
                                      <i className="bi bi-geo-alt-fill text-danger"></i>{" "}
                                      {item.address},{" "}
                                      <span className="fw-bold">{item.city}</span>,{" "}
                                      <span className="fw-bold">{item.state}</span>,
                                      <span className="fw-bold">
                                        Pin - {item.zipcode}
                                      </span>
                                    </p>
                                    <div className="text-center profile_btn_cntn_11">
                                      <button
                                        className="remove-button"
                                        onClick={() => deleteSellerAddressFun(item._id, index)}
                                      >
                                        <i className="fa fa-trash mx-1"></i>
                                      </button>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <></>
                            )}
                            <div className="dis-flex justify-content-center second-info mt-1 add-address-button h-auto profile_add_card cursor-pointer main-color f-700" onClick={() => setaddressshow(true)}>
                              + Add Address
                            </div>
                          </div>
                        </Card> :
                        <ManageAddress vendorId={vendorId} updateResponseData={updateResponseData} profile={responseData} changeStep={changeStep} />}
                    </div>

                  )}

                  {/* Address Modal */}

                  <Modal
                    show={addressshow}
                    onHide={handleAddressClose}
                    backdrop="static"
                    size="lg"
                  >
                    <div class="header-pop p-3"><div class="header-title">Add Address</div><a class="close-pop" onClick={() => handleAddressClose()}>×</a></div>
                    <Modal.Body className="updtProPopModal_body">
                      {/* <a className="close fs-30" onClick={handleAddressClose}>
                      &times;
                    </a> */}
                      <AddnewAddressSeller
                        response={handleResAddress}
                        popupVisibility={handleAddressClose}
                      />
                    </Modal.Body>
                  </Modal>
                </div>
              }
              {step == 'step3' &&
                <div >
                  <BankDetails vendorId={vendorId} updateResponseData={updateResponseData} changeStep={changeStep} profile={responseData} data={bankDetail} />
                </div>
              }

              {/* Agreement document */}
              {step == 'step4' &&
                <div >
                  <AgreementDocument />
                </div>
              }

              {/* Third panel */}
              {step == 'step5' &&
                <div >
                  <SellerSupport />
                </div>
              }
              {/* Fourth panel */}
              {step == 'step6' &&
                <div >
                  <Card className=" card-box text-dark text-center prof_coming_soon">
                    <div>
                      <p>Coming Soon...</p>
                    </div>
                  </Card>
                </div>
              }

              {/* Fifth Panel */}
              {/* <div id="sixth-panel" class="panel animated slideInRight">
              {step=='step7'&&
              <div >
                <Card className=" card-box text-dark text-center prof_coming_soon">
                  <div>
                    <p>Coming Soon...</p>
                  </div>
                  <LegalPolicy />
                </Card>
              </div> */}
              {step == 'step8' &&
                <div>
                  <Card className=" card-box">

                    <LegalPolicy />
                  </Card>
                </div>
              }
              {/* <div id="seventh-panel" class="panel animated slideInRight">
                <Card className=" card-box text-dark text-center prof_coming_soon">
                  <div>
                    <p>Coming Soon1111fdg1111...</p>
                  </div>
                </Card>
              </div> */}
              {/* } */}
              {step == 'complete' &&
                <div >
                  <StepComplete />
                </div>
              }
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Profile;
